// src/lib/publicTokenPath.ts
//
// The public, no-login routes whose PATH is a bearer credential:
// `/sign/:token` (the seller's NDA signing link — spec §6 keeps only its
// SHA-256 at rest, decision 9) and `/documents/:token` (the seller's upload
// link). Both routes render inside the app-wide `AnalyticsProvider`, which
// writes the path of every route a logged-in user visits to `page_views`
// and `error_tracking` — so a staff member who opens a link
// `send_nda` handed back, to check it before forwarding it, would otherwise
// leave a live signing token in a staff-readable table indefinitely.
//
// `analytics.service.ts` runs every path it stores through
// `redactPublicTokenPath`, so the rows say `/sign/:token` and nothing else.
// Zero imports: vitest imports it directly.

const PUBLIC_TOKEN_PATH = /^\/(sign|documents)\/[^/?#]+/;

/** The path with a public route's token replaced by `:token`; any other path
 *  (and a missing one) is returned unchanged. */
export function redactPublicTokenPath<T extends string | null | undefined>(path: T): T {
  if (typeof path !== 'string') return path;
  return path.replace(PUBLIC_TOKEN_PATH, '/$1/:token') as T;
}
